import {withRouter} from "react-router-dom"
import React from "react"
import {ClubPlatformProvider} from "./store/useClubPlatformContext"
import ClubPlatformLayout from "./layout"

const ClubPlatform = () => {


    return (
        <div>
            <ClubPlatformProvider>
                <ClubPlatformLayout/>
            </ClubPlatformProvider>
        </div>
    )
}

export default withRouter(ClubPlatform)




// WEBPACK FOOTER //
// ./src/containers/ClubPlatform/index.js